<template>
    <div class="slider">
        <span>Drag</span>
    </div>
</template>

<script>
import resize from 'vue-resize-directive';
import { isMobileOnly } from 'mobile-device-detect';
import { mapState } from 'vuex';
export default {
    directives: { resize },
    props: ['updateSliderPos', 'overridePos'],
    data() {
        return {
            sliderPos: 0,
            sliderMoved: false,
            clicked: false,
            bounds: {
                left: 0,
                right: window.innerWidth
            }
        };
    },
    computed: {
        ...mapState('spinner', ['controls', 'loadFinished']),
        isPortraitMode() {
            return isMobileOnly || window.innerWidth < 1024;
        }
    },
    mounted() {
        // this.resetSliderPos();
        window.addEventListener('resize', this.onResize);
        this.$el.addEventListener('mousedown', this.slideReady);
        this.$el.addEventListener('touchstart', this.slideReady);
        window.addEventListener('mouseup', this.slideFinish);
        window.addEventListener('touchend', this.slideFinish);
        window.addEventListener('mousemove', this.slideMove);
        window.addEventListener('touchmove', this.slideMove);
    },
    methods: {
        resetSliderPos() {
            this.sliderPos = window.innerWidth / 2;
        },
        slideReady() {
            this.clicked = true;
            this.controls.enabled = false;
        },
        slideFinish() {
            this.clicked = false;
            this.controls.enabled = true;
        },
        slideMove(e) {
            if (!this.clicked) return false;
            this.sliderMoved = true;
            this.sliderPos = e.pageX || e.touches[0].pageX;
            //prevent the slider from being positioned outside the window bounds
            if (this.sliderPos < this.bounds.left)
                this.sliderPos = this.bounds.left;
            if (this.sliderPos > this.bounds.right)
                this.sliderPos = this.bounds.right;
        },
        checkBounds() {
            if (this.isPortraitMode) {
                this.bounds.left = 0;
                this.bounds.right = window.innerWidth;
            } else {
                const buffer = 30;
                const navEl = document.getElementsByClassName('navigation')[0];
                const infoEl = document.getElementsByClassName('info-panel')[0];
                if (navEl && infoEl) {
                    const navRect = navEl.getBoundingClientRect();
                    const infoRect = infoEl.getBoundingClientRect();
                    this.bounds.left = navRect.right + buffer;
                    this.bounds.right = infoRect.left - buffer;
                }
            }
        },
        onResize() {
            // eslint-disable-next-line no-console
            console.log('resize');
            this.resetSliderPos();
            this.checkBounds();
        }
    },
    watch: {
        loadFinished() {
            this.checkBounds();
        },

        sliderPos() {
            this.$el.style.left =
                this.sliderPos - this.$el.offsetWidth / 2 + 'px';
            this.updateSliderPos(this.sliderPos);
        },

        overridePos() {
            this.sliderPos = this.overridePos;
        }
    }
};
</script>

<style lang="scss">
.slider {
    position: absolute;
    cursor: ew-resize;
    top: 50%;
    left: 0%;
    z-index: 10000;
    opacity: 0;

    span {
        width: 4em;
        height: 4em;
        background-color: #62bb46;
        color: #ffffff;
        text-transform: uppercase;
        border-radius: 50%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        align-content: center;
        justify-content: center;
        align-items: center;
        position: absolute;
    }

    &:before {
        content: '';
        position: absolute;
        width: 0.125em;
        background-color: rgba(158, 158, 158, 0.7);
        height: 100vh;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
</style>
